import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { InputGroup as FormInputGroup } from '../../form'

export { default as Header } from './Header'
export { default as AuthToken } from './AuthToken'
export { default as Center } from './Center'
export { default as Terms } from './Terms'
export { default as FacebookLogin } from './FacebookLogin'
export { default as GoogleLogin } from './GoogleLogin'
export { default as AppleLogin } from './AppleLogin'

export const FormContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px;

  @media (min-width: 768px) {
    padding: 40px 0;
  }

  @media (min-width: 992px) {
    padding: 0;
  }
`

export const Heading = styled.h2`
  display: none;
  margin: 0;
  margin-bottom: 80px;
  font-size: 30px;
  text-align: center;

  @media (min-width: 992px) {
    display: block;
  }
`

export const Column = styled.div`
  ${({ theme, border }) =>
    border &&
    `
    @media (min-width: 992px) {
      border-right: 1px solid ${theme.colors.borderGrey};
    }
  `}

  @media (min-width: 992px) {
    padding: 80px;
  }
`

export const AuthLink = styled(NavLink)`
  display: block;
  position: relative;
  color: white !important;
  text-decoration: none !important;
  font-size: 24px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0 1.5em;
  opacity: 0.3;

  transition: opacity 300ms ease-out;

  &:hover,
  &.active {
    opacity: 1;
  }

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &:after {
    content: '';
    position: absolute;
    width: 1.5em;
    height: 0.2em;
    background: white;
    bottom: -0.5em;
    left: 50%;
    margin-left: -0.75em;
  }

  @media (min-width: 768px) {
    font-size: 32px;
  }
`

export const InputGroup = styled(FormInputGroup)`
  @media (min-width: 768px) {
    margin-bottom: 40px;
  }
`
